import { whatsNew_FlexPane_Title } from 'owa-locstrings/lib/strings/whatsnew_flexpane_title.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import { WhatsNewPane } from 'owa-header-pane';
import { HeaderCharmType, getActiveCharm, toggleCharm } from 'owa-header-store';
import { getUnreadWhatsNewCardNumber, initializeWhatsNewLazy } from 'owa-whats-new';
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { logUsage } from 'owa-analytics';
import { getPendingGetStartedTaskCount } from 'owa-get-started/lib/selectors/getPendingGetStartedTaskCount';
import { showO365ShellHeader, openFlexPane } from 'owa-suite-header-apis';
import { WHATSNEW_FLEXPANE_ID } from '../constants';
import { isGetStartedInListViewEnabled } from 'owa-get-started/lib/utils/isGetStartedInListViewEnabled';
import { isGetStartedInFlexPaneEnabled } from 'owa-get-started/lib/utils/isGetStartedInFlexPaneEnabled';

@observer
export default class WhatsNewCharm extends React.Component<{}, {}> {
    componentDidMount() {
        initializeWhatsNewLazy.import().then(initializeWhatsNew =>
            initializeWhatsNew().then(expandFlexpane => {
                if (expandFlexpane && this.isWhatsNewPaneEnabled()) {
                    if (!showO365ShellHeader()) {
                        toggleCharm(HeaderCharmType.WhatsNewCharm);
                    } else {
                        openFlexPane(WHATSNEW_FLEXPANE_ID);
                    }
                }
            })
        );
    }

    render() {
        if (this.isWhatsNewPaneEnabled()) {
            return (
                <div>
                    <HeaderCharm
                        key="whatsnew"
                        icons={{
                            iconName: ControlIcons.Megaphone,
                        }}
                        title={loc(whatsNew_FlexPane_Title)}
                        ariaLabel={loc(whatsNew_FlexPane_Title)}
                        behavior={{
                            paneComponent: showO365ShellHeader() ? null : WhatsNewPane,
                            charm: HeaderCharmType.WhatsNewCharm,
                            onClick: this.onWhatsNewClicked,
                        }}
                        getBadgeCount={getUnreadWhatsNewCardNumber}
                    />
                </div>
            );
        }

        return null;
    }

    private onWhatsNewClicked = () => {
        if (getActiveCharm() != HeaderCharmType.WhatsNewCharm) {
            logUsage('whatsNewCharmClicked');
        }

        if (!showO365ShellHeader()) {
            toggleCharm(HeaderCharmType.WhatsNewCharm);
        }
    };

    private isWhatsNewPaneEnabled = (): boolean => {
        return (
            isGetStartedInListViewEnabled() ||
            !isGetStartedInFlexPaneEnabled() ||
            getPendingGetStartedTaskCount() === 0
        );
    };
}
